import { useQuery } from '@tanstack/react-query'
import { getCompaniesForFilters } from 'api/companies'
import { companiesForFiltersKey } from './keys'

type CompaniesForFilters = Awaited<ReturnType<typeof getCompaniesForFilters>>

type UseCompaniesForFiltersQueryParams = Parameters<
  typeof getCompaniesForFilters
>[0]

export const useCompaniesForFiltersQuery = (
  params: UseCompaniesForFiltersQueryParams
) => {
  return useQuery<CompaniesForFilters, Error>({
    queryKey: [...companiesForFiltersKey, params.grouping],
    queryFn: () => getCompaniesForFilters(params),
  })
}
